import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Ambetter",
  shortName: "Ambetter",
  slug: "ambetter-insurance",
  seoTitle: "Ambetter TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Ambetter insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Ambetter marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Ambetter TMS coverage, Ambetter TMS therapy, Ambetter depression treatment Florida, Ambetter mental health benefits Coral Springs FL, Ambetter SAINT TMS",
  planType: "Health Insurance Marketplace plan (Centene subsidiary)",
  planRegion: "nationwide marketplace plans",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health and substance use services",
  planSpecificIntro:
    "Ambetter is a health insurance brand offered through the Health Insurance Marketplace (Healthcare.gov), underwritten by Centene Corporation. Ambetter plans are designed for individuals and families purchasing coverage through the ACA marketplace and include behavioral health benefits as an essential health benefit. These benefits may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Ambetter offers multiple tier levels — Bronze, Silver, Gold, and Platinum — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan, metal tier, and network.",
  officialResourceUrl: "https://www.ambetterhealth.com/",
  officialResourceLabel: "Ambetter official website",
};

export const AmbetterInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AmbetterInsurance;
